import React from "react";
import styled, { useTheme } from "styled-components";
import { iconSize, textStyle } from "../../dimensions";
import IconButton from "../utils/IconButton";
import { InfoICircledIcon } from "../../icons";
import { statusesWithWayfinding } from "../TicketCardv2/TicketCardv2";
import VisuallyHidden from "../utils/VisuallyHidden";
var ticketTypesWithDisabledColor = ["disabled", "transfer", "resale"];
var TicketInfoHeader = function TicketInfoHeader(_ref) {
  var accessibleTitle = _ref.accessibleTitle,
    headerTitle = _ref.headerTitle,
    ticketInfoButtonData = _ref.ticketInfoButtonData,
    type = _ref.type,
    wayfindingColors = _ref.wayfindingColors;
  var theme = useTheme();
  var getIconFillColor = function getIconFillColor() {
    if (wayfindingColors && statusesWithWayfinding.includes(type)) {
      return wayfindingColors.foreground;
    } else if (ticketTypesWithDisabledColor.includes(type)) {
      return theme.text.secondary;
    } else {
      return "info";
    }
  };

  // Displays accessibleTitle as headerTitle if no headerTitle is given / is empty string
  return /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(HeaderTitle, {
    $type: type,
    $wayfindingColors: wayfindingColors,
    translate: "no"
  }, headerTitle || accessibleTitle), accessibleTitle && headerTitle && /*#__PURE__*/React.createElement(AccessibleTitle, {
    $type: type,
    $wayfindingColors: wayfindingColors,
    translate: "no"
  }, accessibleTitle), (ticketInfoButtonData === null || ticketInfoButtonData === void 0 ? void 0 : ticketInfoButtonData.callback) && /*#__PURE__*/React.createElement(CtaContent, null, /*#__PURE__*/React.createElement(TicketInfoButton, {
    onClick: ticketInfoButtonData.callback
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, ticketInfoButtonData.accessibleDescription), /*#__PURE__*/React.createElement(InfoICircledIcon, {
    fillColor: getIconFillColor()
  }))));
};
export default TicketInfoHeader;
var HeaderContainer = styled.div.withConfig({
  displayName: "TicketInfoHeader__HeaderContainer",
  componentId: "sc-101wb79-0"
})(["display:grid;grid-template-rows:1fr auto;grid-template-columns:0.5fr 3fr 0.5fr;width:100%;"]);
var HeaderTitle = styled.h2.withConfig({
  displayName: "TicketInfoHeader__HeaderTitle",
  componentId: "sc-101wb79-1"
})(["grid-row-start:1;grid-column-start:2;margin:0;", ";color:", ";text-align:center;"], function (_ref2) {
  var $type = _ref2.$type;
  if ($type === "addedValue") return textStyle.fiji;
  return textStyle.etna;
}, function (_ref3) {
  var $type = _ref3.$type,
    $wayfindingColors = _ref3.$wayfindingColors,
    theme = _ref3.theme;
  if ($wayfindingColors && statusesWithWayfinding.includes($type)) {
    return $wayfindingColors.foreground;
  } else if (ticketTypesWithDisabledColor.includes($type)) {
    return theme.text.secondary;
  } else {
    return "initial";
  }
});
var AccessibleTitle = styled.h3.withConfig({
  displayName: "TicketInfoHeader__AccessibleTitle",
  componentId: "sc-101wb79-2"
})(["", " grid-row-start:2;grid-column-start:2;margin:0;color:", ";text-align:center;"], textStyle.snowdon, function (_ref4) {
  var $type = _ref4.$type,
    $wayfindingColors = _ref4.$wayfindingColors,
    theme = _ref4.theme;
  if ($wayfindingColors && statusesWithWayfinding.includes($type)) {
    return $wayfindingColors.foreground;
  } else {
    return theme.text.secondary;
  }
});
var CtaContent = styled.div.withConfig({
  displayName: "TicketInfoHeader__CtaContent",
  componentId: "sc-101wb79-3"
})(["display:flex;grid-row-start:1;grid-column-start:3;align-items:center;justify-content:flex-end;height:1.25rem;"]);
var TicketInfoButton = styled(IconButton).withConfig({
  displayName: "TicketInfoHeader__TicketInfoButton",
  componentId: "sc-101wb79-4"
})(["position:relative;right:-", ";cursor:pointer;"], iconSize.margin);